const Types = {
  account: {
    url: '/settings',
  },
  connect_card_submission: {
    url: '/connect/cards',
  },
  contact: {
    url: '/contacts/:hash',
    default: '/contacts',
  },
  file: {
    url: '/files',
  },
  group: {
    url: '/groups/:hash',
    default: '/groups',
  },
  integration: {
    url: '/settings/integrations',
  },
  message: {
    url: '/messages',
  },
  task: {
    url: '/tasks/all/:hash/comments',
    default: '/tasks/all',
  },
  tax_exempt_form: {},
};
export const getUrl = (n) => {
  const { creating_object_type, creating_object_hash } = n;
  if (!creating_object_type) return '';
  const type = Types[creating_object_type];
  if (!type) return '';
  const { url } = type;
  if (!url) return '';
  if (creating_object_hash) return url.replace(':hash', creating_object_hash);
  return type.default || url;
};
